module.exports = __webpack_public_path__ + "public/img/使用中.fa30fa09.png";